import GroupCompaniesSection from '@/containers/OurLeadership/GroupCompaniesSection';
import { useSettingsContext } from '@/contexts/SettingsContext';
import { TypeOurPeopleWithoutUnresolvableLinksResponse } from '@/features/contentful/_generated';

type T_GroupCompaniesSettings = {
    groupCompanies: string;
    handleModalOpen: (entityId: string) => void;
};

const GroupCompanies = ({
    hidePreview = false,
    peoples,
    handleModalOpen,
}: {
    hidePreview?: boolean;
    peoples: TypeOurPeopleWithoutUnresolvableLinksResponse[];
    handleModalOpen: (entityId: string) => void;
}) => {
    const settings = useSettingsContext();

    const tabSettings = settings.contentfulSettings.tabs as Pick<
        T_GroupCompaniesSettings,
        'groupCompanies'
    >;
    const companyAssociations = tabSettings.groupCompanies.split(',');

    return (
        <>
            {companyAssociations.map((i) => (
                <GroupCompaniesSection
                    key={i}
                    peoples={peoples.filter((p) => p.fields.companyAssociation === i.trim())}
                    currentDepartment={i}
                    handleModalOpen={handleModalOpen}
                    hidePreview={hidePreview}
                />
            ))}
        </>
    );
};

export default GroupCompanies;
